import type {TuiCapData} from './tuicap-engine'
import {TuiCapPlayer, type TuiCapPlayerProps} from './TuiCapPlayer'

// Loaded lazily (its own chunk) when the player nears the viewport.
const load = () => import('./demo-desktop.tuicap.json') as unknown as Promise<{default: TuiCapData}>

export default function DemoDesktop(props: Omit<TuiCapPlayerProps, 'data' | 'load' | 'cols' | 'rows'>) {
  return <TuiCapPlayer load={load} cols={110} rows={28} {...props} />
}
